module.exports = __webpack_public_path__ + "img/fisica-cotidiana.7a599170.jpg";